import SimpleList from 'Components/SimpleList';
import SitesList from 'Components/SimpleList/Sites';
import { uniqBy } from 'lodash';
import React from 'react';
import { unixToDate } from 'utils/date';
import displayMetadata from 'utils/displayMetadata';

const generateEquipmentProperties = equipment => {
    const
        sites = uniqBy(equipment.devices?.map(({ site_id, site_name }) => ({ id: site_id, name: site_name })), 'id') || [],
        organizations = uniqBy(equipment.devices?.map(({ organization_id, organization_name }) => ({ id: organization_id, name: organization_name })), 'id') || [];

    return [
        { label: 'ID', content: equipment.id },
        { label: 'Name', content: equipment.name },
        { label: 'Description', content: equipment.description },
        { label: 'Usable?', content: equipment.usable ? 'Yes' : 'No' },
        { label: 'Equipment category', content: equipment.equipment_category_name },
        { label: 'Equipment type', content: equipment.equipment_type_name },
        { label: 'Input protocol', content: equipment.in_protocol_name },
        { label: 'Output protocol', content: equipment.out_protocol_name },
        { label: `Sites (${sites.length})`, content: <SitesList route="sites" rows={sites}/> },
        { label: `Organizations (${organizations.length})`, content: organizations.map(({ name }) => name).sort().join(', ') },
        { label: 'Device Count', content: equipment.devices_count },
        { label: 'Creation', content: `${equipment.creator_name} @ ${unixToDate(equipment.created_at)}` },
        { label: 'Update', content: `${equipment.updater_name} @ ${unixToDate(equipment.updated_at)}` }
    ];
};

const Details = props => {
    const { model } = props;

    const content = [
        ...generateEquipmentProperties(model),
        ...displayMetadata(model)
    ];

    return (
        <SimpleList content={content}/>
    );
};

export default Details;
